<template>
  <v-card>
    <v-container style="max-width: 900px">
      <v-row>
        <v-col cols="12" class="d-flex justify-center">
          <v-btn-toggle rounded class="mx-auto">
            <v-btn color="white" :to="{name: 'renting'}">For Tenants</v-btn>
            <v-btn color="primary" class="white--text" :to="{name: 'renting-out'}">For Landlords</v-btn>
          </v-btn-toggle>
        </v-col>

        <v-col cols="12">
          <section class="text-center">
            <h1>For Landlords</h1>
            <p class="lead">FIND QUALITY RESIDENTS for YOUR Property with LocalRent.Online!</p>
          </section>
          <ul class="py-3 px-0" style="list-style: none">
            <li>Looking for Quality residents to Rent your place who will pay Ontime?</li>
            <li>You are busy managing properties and looking for an easy way to find Tenants?</li>
          </ul>
          <p>We understand how Frustrating it can be to find good Tenants for your House, Apartment or a Room. That is why we Created LocalRent.Online to help Property Owners and Managers just like you to help find good Tenants.</p>
          <div class="text-center">
            <v-btn
              rounded
              color="primary"
              :to="authenticated ? {name: 'my-adverts-edit'} : null"
              @click="openAuth"
            >LIST YOUR PROPERTY</v-btn>
          </div>

          <v-row
            align="center"
            justify="center"
            class="py-12"
            :key="index"
            v-for="(feature, index) in features"
          >
            <v-col cols="12" md="6" :order-md="index % 2 == 0 ? 'last' : 'first'">
              <h1 class="display-1 mb-5 font-weight-bold">{{feature.title}}</h1>
              <p class="body-2">{{feature.body}}</p>
            </v-col>
            <v-col cols="12" md="6">
              <div class="icon-circle">
                <v-img max-width="80%" class="mx-auto" :src="feature.img"></v-img>
              </div>
            </v-col>
          </v-row>
          <p>IMAGINE how you will feel when you receive your monthly RENT payments ON TIME and your property is kept well by GOOD tenants, that treat it like their own!</p>
          <p>Why to keep your property Vacant and continue to lose income?</p>
          <p>List your House/Apartment/Room Today with LocalRent.Online and Let it start bringing you INCOME!</p>
        </v-col>
      </v-row>
      <div class="text-center">
        <v-btn
          rounded
          color="primary"
          :to="authenticated ? {name: 'my-adverts-edit'} : null"
          @click="openAuth"
        >LIST YOUR PROPERTY</v-btn>
      </div>
    </v-container>
  </v-card>
</template>

<script>
import EventBus from "../event_bus";
import { mapState } from "vuex";

export default {
  computed: {
    ...mapState("auth", {
      authenticated: "authenticated",
    }),
  },
  data() {
    return {
      features: [
        {
          title: "Fast and Easy Listing",
          body:
            "It takes just a few moments to make your new listing visible nationwide.",
          img: require("@/assets/home/pics_fast-easy-listing.svg"),
        },
        {
          title: "Almost Free",
          body:
            "You do not have to spend $$$ to find a good renter. Most of them are just within your reach",
          img: require("@/assets/home/pics_almost-free.svg"),
        },
        {
          title: "Long Term Relationships",
          body:
            "Using the latest technology to match and connect with your future tenant who will treat your property like their own.",
          img: require("@/assets/home/pics_long-term-relationship.svg"),
        },
      ],
    };
  },
  methods: {
    openAuth() {
      EventBus.$emit("requiresAuth");
    },
  },
};
</script>

<style lang="scss" scoped>
</style>